<template>
    <div class="reporter-container">
        <div class="line"></div>
        <div class="title-box">
            <span class="title">记者专栏</span>
        </div>
        <div class="list-box">
            <ul>
                <li v-for="(item, i) in reporterList" :key="i">
                    <img :src="item.img" alt="">
                    <span>{{item.name}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ReporterComponent',
    data() {
        return {
            reporterList: []
        }
    },
    created() {
        this.getReporterList();
    },
    methods: {
        getReporterList() {
            this.reporterList = [
                {
                    img: 'https://cdn.bigbays.cn/test/imgs/timg9.png',
                    name: '罗西'
                },
                {
                    img: 'https://cdn.bigbays.cn/test/imgs/timg10.png',
                    name: '凉生'
                },
                {
                    img: 'https://cdn.bigbays.cn/test/imgs/timg3.png',
                    name: '刘云飞'
                },
                {
                    img: 'https://cdn.bigbays.cn/test/imgs/timg4.png',
                    name: '陈艳曲'
                }
            ];
        },
    }
}
</script>
<style lang="scss" scoped>
@import './ReporterComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/reporter/ReporterComponent.vue